import React, { Fragment, useContext, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import { Link, useParams } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { BreadCrumbs } from './BreadCrumbs';
import { AppConfig } from '../../AppConfig';
import { AppHelper } from '../../helpers/AppHelper';
import { CustomHeaderbarStyles } from '../../styles/CustomStyles';
import { AppContext } from '../../common/contexts/AppContext';
import Tooltip from '@material-ui/core/Tooltip';
import { Controller } from '../Controller';
import { SettingsMenu } from './SettingsMenu';
import { OrgSwitcher } from './OrgSwitcher';
import { AppButton } from './AppButton';
import {Helper} from '../helpers/Helper'

export function Headerbar(props) {
  const appUser = Controller.get().userMgr().getAppUser()
  const { appData, appContextStateHandler } = useContext(AppContext)
  const pagePadding = AppTheme.adminPagePadding * 2
  const headerbarWidth = () => {
    return (appData && appData.toggleDrawer) ? (window.innerWidth - AppTheme.drawerWidth - pagePadding) : (window.innerWidth)
  }
  const { orgId } = useParams();
  const [state, setState] = useState({
    settingPopover: null,
    orgSwitcherDialog: false,
    selectedOrgId: orgId
  })

  useEffect(() => {
    appContextStateHandler({ pageKey: props.pageKey })
  }, [])

  const settingOpen = (e) => {
    setState({ ...state, settingPopover: e.currentTarget })
  }

  const settingClose = () => {
    setState({ ...state, settingPopover: null })
  }

  const orgSwitcherDialogOpen = () => {
    setState({ ...state, orgSwitcherDialog: true, settingPopover: null });
  }

  const orgSwitcherDialogClose = () => {
    setState({ ...state, orgSwitcherDialog: false, settingPopover: null, selectedOrgId: orgId });
  }

  const onOrgChange = event => {
    setState({ ...state, [event.target.name]: event.target.value });
  }

  const doActionSave = () => {
    Controller.get().roleHelper().setCurrentOrgInfo(state.selectedOrgId)
    setState({ ...state, orgSwitcherDialog: false })
    // const pathname = '/admin/orgs/' + state.selectedOrgId
    const pathname = Controller.get().roleHelper().getHome()
    window.location.href = pathname
    //Controller.get().pushRoute(pathname);
  }

  const handleBackNavigation = () => {
    if(props.breadCrumbs && props.breadCrumbs.length > 2) {
      Controller.get().pushRoute(props.breadCrumbs[props.breadCrumbs.length - 2].to);
    }
  }

  const getOrgLogo = () => {
    const currentOrg = Controller.get().roleHelper().getOrg()
    return currentOrg.logo || AppConfig.LOGO
  }

  return (
    <div className={css(Styles.container)} style={{ width: headerbarWidth() }}>
      <Link to={Controller.get().roleHelper().getHome()}>
        <div className={css(Styles.logoContainer)}>
          {appData.org &&
          <img
            src={appData.org.logo}
            alt={AppConfig.NAME}
            width='250'
            height='100'
            className={css(Styles.img)} />
          }
        </div>
      </Link>
      <div className={css(Styles.containerNarrow)}>
        <div className={css(
          Styles.containerTitle,
          props.pageKey === 'CampaignVenues' && Styles.campaignVenuesContainerTitle
        )}>
          {props.breadCrumbs && props.breadCrumbs.length > 2 && AppHelper.isMobileview() &&
            <i
              className='material-icons-outlined'
              style={{
                fontSize: 20,
                margin: 0,
                color: AppConfig.TINT_COLOUR,
              }}
              onClick={() => handleBackNavigation()}>
                arrow_back_ios
            </i>
          }
          <div className={css(
            Styles.containerTitleContent,
            props.pageKey === 'CampaignVenues' && Styles.campaignVenuesContainerTitleContent
          )}>
            <h1 className={css(
              Styles.title,
              props.pageKey === 'CampaignVenues' && Styles.campaignVenuesTitle
            )}>{props.title}</h1>
          </div>
          <BreadCrumbs breadCrumbs={props.breadCrumbs} />
        </div>
        <div className={css(Styles.containerButton)}>
          {props.actionComponents && props.actionComponents.map((actionComponent, index) => {
            return (
              <div key={'actionComponent_' + index} className={css(Styles.actionComponent)}>
                {actionComponent}
              </div>
            )
          })}
          {props.actions && props.actions.map((actionItem, index) => {
            if (actionItem.type === 'icon') {
              return (
                <div className={css(Styles.link, actionItem.linkStyle)} key={index}>
                  <Tooltip title={actionItem.tooltip} arrow classes={{ popper: css(Styles.tooltip) }}>
                    <div className={css(Styles.imageContainer, actionItem.containerStyle || '')} onClick={actionItem.onClick}>
                      <i className={ css(actionItem.iconStyle || '') + ' material-icons-outlined'} style={{ fontSize: 20, margin: 14, color: '#222222'}} >{actionItem.icon}</i>
                    </div>
                  </Tooltip>
                </div>
              )
            } else if (actionItem.type === 'icon-mobile' && AppHelper.isMobileview()) {
              return (
                <div className={css(Styles.link)} key={index}>
                  <Tooltip title={actionItem.tooltip} arrow classes={{ popper: css(Styles.tooltip) }}>
                    <div className={css(Styles.imageContainer, Styles.imageContainerVariant)} onClick={actionItem.onClick}>
                      <i className='material-icons-outlined' style={{ fontSize: 20, margin: 14, color: '#ffffff' }} >{actionItem.icon}</i>
                    </div>
                  </Tooltip>
                </div>
              )
            } else {
              return (
                <AppButton
                  key={index}
                  buttonStyle={Styles.button}
                  onClick={actionItem.onClick}
                  buttonText={actionItem.label}
                  icon={actionItem.icon || 'add'}
                />
              )
            }
          })}

          <Fragment>
            {(appUser && appUser.orgs && appUser.orgs.length > 1 && !Controller.get().userMgr().isProductSU()) &&
            <AppButton
              onClick={orgSwitcherDialogOpen}
              buttonText={Helper.getString('orgSwitcher')}
            />
            }
            <div className={css(Styles.link, Styles.settingButton)} onClick={(e) => settingOpen(e)}>
              <Tooltip title={'Settings'} arrow classes={{ popper: css(Styles.tooltip) }}>
                <div className={css(Styles.imageContainer)}>
                  <i className='material-icons-outlined' style={{ fontSize: 20, margin: 14, color: '#222222' }}>settings</i>
                </div>
              </Tooltip>
            </div>
          </Fragment>
        </div>
      </div>
      <SettingsMenu
        settingPopover={state.settingPopover}
        settingClose={settingClose}
        orgId={state.selectedOrgId}
        appData={appData}
        orgSwitcherDialogOpen={orgSwitcherDialogOpen} />
      <OrgSwitcher
        orgSwitcherDialog={state.orgSwitcherDialog}
        orgSwitcherDialogClose={orgSwitcherDialogClose}
        inProcess={state.inProcess}
        selectedOrgId={state.selectedOrgId}
        onOrgChange={onOrgChange}
        doActionSave={doActionSave} />
    </div>
  );
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomHeaderbarStyles : StyleSheet.create({
  logoContainer: {
    width: '100% !important',
    marginTop: '10px !important',
    textAlign: 'center',
    borderBottom: 'solid 1px #ccc',
    '@media (min-width: 1024px)': {
      display: 'none'
    },
  },
  img: {
    width: 'auto',
    height: 50
  },
  container: {
    position: 'fixed',
    top: 0,
    paddingTop: AppTheme.toolbarHeight ? 0 : 20,
    paddingBottom: AppTheme.toolbarHeight ? 0 : 20,
    minHeight: AppTheme.toolbarHeight, //TODO: creates issue in mobile view
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBg,
    zIndex: 1000,
    maxWidth: AppTheme.viewPort,
    marginLeft: AppTheme.adminPagePadding,
    marginRight: AppTheme.adminPagePadding,
    '@media (max-width: 1024px)': {
      width: '-webkit-fill-available',
      minHeight: 70,
      display: 'flex !important',
      flexDirection: 'column'
    },
    '@media (max-width: 767px)': {
      marginLeft: 10,
      marginRight: 10,
    }
  },
  containerNarrow: {
    maxWidth: AppTheme.viewPort,
    display: 'flex',
    flex: 1,
    '@media (max-width: 1024px)': {
      display: 'flex !important',
      flexDirection: 'row !important',
      justifyContent: 'space-between !important'
    }
  },
  title: {
    color: 'black',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 30,
    marginBottom: 10,
    '@media (max-width: 767px)': {
      fontSize: 20
    },
    '@media (max-width: 1024px)': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      display: 'block !important'
    }
  },
  containerButton: {
    display: 'flex',
    gap: 10,
    justifyContent: 'flex-end',
    alignItems: 'center',
    '@media (max-width: 1024px)': {
      marginBottom: 10,
      marginTop: 5,
      alignItems: 'center !important',
      flexWrap: 'wrap'
    }
  },
  settingButton: {
    '@media (max-width: 1024px)': {
      display: 'none'
    }
  },
  actionComponent: {
    marginLeft: 10
  },
  button: {
    minWidth: 160,
  },
  buttonLabel: {
    marginLeft: 4
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  containerTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    marginRight: 20,
    '@media (max-width: 1024px)': {
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 5,
      flexDirection: 'row'
    }
  },
  containerTitleContent: {
    display: 'grid'
  },
  campaignVenuesContainerTitle: {
    minWidth: 0
  },
  campaignVenuesContainerTitleContent: {
    minWidth: 0
  },
  campaignVenuesTitle: {
    display: 'block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  imageContainer: {
    width: 48,
    height: 48,
    backgroundColor: AppTheme.secondaryBg,
    borderRadius: '50%',
    display: 'flex',
    cursor: 'pointer',
  },
  imageContainerVariant: {
    backgroundColor: AppTheme.primaryColor,
  },
  link: {
    textDecoration: 'none',
    marginLeft: 20,
    '@media (max-width: 767px)': {
      marginLeft: 5,
    }
  },
})



// WEBPACK FOOTER //
// ./src/common/components/Headerbar.js